export const LAND_WIDTH_OPTIONS = [8.5, 10, 10.5, 12, 12.5, 14];
export const LAND_DEEP_OPTIONS = [21, 25, 28];
